'use strict';

class IdenticalList {
  constructor($scope, $interval, invoiceService, StoreService, originatorService) {
    this.$scope = $scope;
    this.$interval = $interval;
    this.invoiceService = invoiceService;
    this.originatorService = originatorService;
    this.processing = new StoreService();
  }

  $onInit() {
    this.offset = 0;
    this.limit = 10;
    this.total = 0;
    this.currentPage = 1;

    this.recipients = [];
    this.identicals = [];
    this.failures = [];
    this.selected = null;

    this.loadIdenticals();

    this.originatorService.get()
      .then((resp) => {
        this.originator = resp.data;
      });

    // check status
    let check = this.$interval(() => {
      if (this.processing.length()) {
        this.loadStatus();
      } else {
        this.$interval.cancel(check);
      }
    }, 3000);
  }

  /**
   * Load the status of the batch
   */
  loadStatus() {
    this.processing.reset();
    if (this.identicals && this.identicals.length) {
      this.identicals.forEach((identical) => {
        this.invoiceService.getIdenticalInvoiceStatus(identical.number)
          .then((resp) => {
            identical.status = resp.data.status ? resp.data.status : 'CREATED';

            if (identical.status === 'ACCEPTED') {
              // add to temporary collection
              this.processing.add(identical);
            } else {
              // remove when it is done
              this.processing.remove(identical);
            }

            return identical;
          });
      }, this);
    }
  }

  loadIdenticals() {
    this.identicals = [];
    this.invoiceService.getIdenticalInvoices({offset: this.offset, limit: this.limit}).then((resp) => {
        if (resp.data) {
          this.identicals = resp.data.identicals;
          this.total = resp.data.total;
          this.numberOfPages();
          this.loadStatus();
        }
      }
    );
  }

  /**
   * Load recipients from the selected identical document
   *
   * @param {Object} identical Selected identical document
   */
  loadRecipients(identical) {
    this.invoiceService.getIdenticalRecipients(identical.number)
      .then((resp) => {
        this.selected = identical;
        this.recipients = resp.data;
      });
  }

  /**
   * Load failed invoices from the selected identical document
   *
   * @param {Object} identical Selected identical document
   */
  loadFailedInvoices(identical) {
    this.invoiceService.getFailedIdenticalInvoices(identical.number)
      .then((resp) => {
        this.selected = identical;
        this.failures = resp.data;
      });
  }

  nextPage() {
    this.offset += this.limit;
    this.currentPage += 1;
    this.loadIdenticals();
  }

  prevPage() {
    this.offset -= this.limit;
    this.currentPage -= 1;
    this.loadIdenticals();
  }

  numberOfPages() {
    return Math.ceil(this.total / this.limit);
  }
}

IdenticalList.$inject = ['$scope', '$interval', 'invoiceService', 'StoreService', 'originatorService'];

const identicalList = {
  controller: IdenticalList,
  template: `
    <div class="row">
      <div class="large-6 columns">
        <h2>Masseutsendelse</h2>
      </div>
      <div class="large-6 columns right-align">
        <a ng-show="$ctrl.originator && $ctrl.originator.giroLayout" role="button" href="#/masseutsendelse/ny" class="button secondary"><i class="fa fa-plus"></i> Ny masseutsendelse</a>
        <a ng-show="$ctrl.originator && !$ctrl.originator.giroLayout" role="button" href="#/masseutsendelse/utengiro/ny" class="button secondary"><i class="fa fa-plus"></i> Ny masseutsendelse</a>
      </div>
    </div>

    <p ng-hide="$ctrl.identicals.length > 10">Masseutsendelse gjør det enkelt å sende mange regninger i én utsendelse. Du fyller ut én regning og så kan du sende den til grupper som du har lagd i kundelisten din. Hvis du har mange kunder som ikke er registrert i SendRegning, eller en oversikt over grupper som kundene dine skal plasseres i kan du sende en Excel fil til <a href="mailto:hjelp@sendregning.no">hjelp@sendregning.no</a>, så vil vi importere dem for deg.</p>
    <p ng-hide="$ctrl.identicals.length">Etter at masseutsendelsene er gjort vil de vises på denne siden og du kan se en liste over hvem som har mottatt regninger for hver utsendelse.</p>

    <div ng-show="$ctrl.identicals.length" class="row">
      <div class="large-6 columns right-align pagination-centered">
        <ul ng-show="$ctrl.numberOfPages() > 1" class="pagination">
          <li class="arrow" ng-show="$ctrl.currentPage > 1"><a href ng-click="$ctrl.prevPage()">&laquo;</a></li>
          <li class="secondary">side <b>{{ $ctrl.currentPage }}</b> av <b>{{ $ctrl.numberOfPages() }}</b></li>
          <li class="arrow" ng-show="$ctrl.currentPage < $ctrl.numberOfPages()"><a href ng-click="$ctrl.nextPage()">&raquo;</a></li>
        </ul>
      </div>
    </div>
    <table ng-show="$ctrl.identicals.length" class="responsive">
      <thead>
        <tr>
          <th></th>
          <th>#</th>
          <th>Navn</th>
          <th>Kommentar</th>
          <th>Dato</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr ng-repeat="identical in $ctrl.identicals | orderBy:identical.number:false track by $index" ng-class="{ success: identical.status === 'ACCEPTED', alert: identical.status === 'FAILED' }">
          <td><i ng-show="identical.international" class="icon icon-flag-en left"></i></td>
          <td class="center-align" ng-switch="identical.status">
            <i ng-switch-when="ACCEPTED" class="fa fa-circle-o-notch fa-spin"></i>
            <i ng-switch-when="FAILED" class="fa fa-times"></i>
            <span ng-switch-when="CREATED">{{ identical.number }}</span>
          </td>
          <td>{{ identical.name }}</td>
          <td>{{ identical.comment | truncate:10 }}</td>
          <td>{{ identical.issued | dateFormat }}</td>
          <td class="right-align nowrap">
            <a role="button" href ng-click="$ctrl.loadRecipients(identical)" class="button small secondary"><i class="fa fa-list"></i> Sendte regninger</a>
            <a ng-show="identical.status === 'FAILED'" role="button" href ng-click="$ctrl.loadFailedInvoices(identical)" class="button small secondary"><i class="fa fa-times"></i> Feilende regninger</a>
            <a ng-show="identical.status !== 'FAILED' && identical.international" role="button" href="#/masseutsendelse/engelsk/{{ identical.number }}" class="button small secondary"><i class="fa fa-copy"></i> Kopier</a>
            <a ng-show="identical.status !== 'FAILED' && !identical.international && $ctrl.originator && $ctrl.originator.giroLayout" role="button" href="#/masseutsendelse/{{ identical.number }}" class="button small secondary"><i class="fa fa-copy"></i> Kopier</a>
            <a ng-show="identical.status !== 'FAILED' && !identical.international && $ctrl.originator && !$ctrl.originator.giroLayout" role="button" href="#/masseutsendelse/utengiro/{{ identical.number }}" class="button small secondary"><i class="fa fa-copy"></i> Kopier</a>
          </td>
        </tr>
      </tbody>
    </table>

    <div ng-show="$ctrl.failures.length">
      <h3 class="subheader">{{ $ctrl.selected.name }} ({{ $ctrl.failures.length }} stk)</h3>

      <table>
        <thead>
          <tr>
            <th>Feilmelding</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="failure in $ctrl.failures track by $index">
            <td>
              {{ failure.message }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div ng-show="$ctrl.recipients.length">
      <h3 class="subheader">{{ $ctrl.selected.name }} ({{ $ctrl.recipients.length }} stk)</h3>

      <table>
        <thead>
          <tr>
            <th>Navn</th>
            <th>Faktura</th>
          </tr>
        </thead>
        <tbody>
          <tr ng-repeat="recipient in $ctrl.recipients track by $index">
            <td><a href="#/kunde/{{ recipient.number }}">{{ recipient.name }}</a></td>
            <td>
              <a role="button" href="#/regning/{{ recipient._links.invoice.number }}" class="button small secondary"><i class="fa fa-eye"></i> Vis regning #{{ recipient._links.invoice.number }}</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  `
};

angular
  .module('SendRegning')
  .component('identicalList', identicalList)
  .config(($routeProvider) => {
    $routeProvider
      .when('/masseutsendelse', {
        title: 'Masseutsendelse',
        template: '<identical-list />',
        secure: true
      });
  });
